import { Bell } from "lucide-react";
import { Badge } from "../../../../shared/components/ui/badge.js";
import { Button } from "../../../../shared/components/ui/button.js";
import { cn } from "../../../../shared/lib/utils.js";

/**
 * Sino de notificações com badge de não lidas.
 * Presentacional: emite onClick; não faz fetch.
 *
 * @param {Object} props
 * @param {number} [props.count=0]
 * @param {() => void} [props.onClick]
 * @param {string} [props.className]
 */
export function NotificationBell({ count = 0, onClick, className }) {
  const unread = Number(count) > 0 ? Number(count) : 0;
  const badgeLabel =
    unread > 99 ? "99+" : unread > 0 ? String(unread) : "";

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn("relative text-white hover:bg-white/10", className)}
      onClick={onClick}
      aria-label="Notificações"
    >
      <Bell className="h-5 w-5" />
      {unread > 0 ? (
        <Badge
          variant="destructive"
          className="absolute -right-1 -top-1 h-5 min-w-5 justify-center px-1"
          aria-live="polite"
          aria-label={`${unread} notificações não lidas`}
        >
          {badgeLabel}
        </Badge>
      ) : null}
    </Button>
  );
}
